import { StoredFile } from '@/store/common.interface';
import { Locales } from '@/store/language.interface';
import { getLabel, getTranslation } from '@/utils/data-display-utils';

export const dataURLtoBlob = (dataurl: string): Blob => {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/);
  if (!mime) {
    throw new Error('Invalid MIME type in Data URL');
  }
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime[1] });
};

export const getAltText = (file: StoredFile, defaultTranslationKey: string, languageEnabled?: Locales[]): string => {
  return getTranslation(file, 'altText', languageEnabled) || getLabel(defaultTranslationKey, languageEnabled);
};
